import React, { useState, useEffect } from 'react';
import { SEARCHSUGGESTIONS } from '../utils/utils';

const Suggestions: React.FC = () => {
  const [__html, setHtml] = useState('');

  useEffect(() => {
    window.Liferay.Service(
      '/journal.journalarticle/get-article-content',
      {
        groupId: window.Liferay.ThemeDisplay.getScopeGroupId(),
        articleId: SEARCHSUGGESTIONS,
        languageId: '',
        '-portletRequestModel': '',
        '-themeDisplay': '',
      },
      setHtml,
    );
  }, []);

  return <div dangerouslySetInnerHTML={{ __html }}></div>;
};

export default Suggestions;
